import { BASE_URL } from '../constants/url.js';
import axios from '../../_snowpack/pkg/axios.js';

export const getData = async (company) => {
  try {
    const response = await axios
      .post(BASE_URL, { company: company })
      .then((res) => res.data)
      .catch((error) => console.log(error));
    return response.results;
  } catch (error) {
    console.error(error);
  }
};
